<template>
    <card>
        <template slot="header">
            <h4 class="card-title">Reparos<!--{{ $t("dashboard.repairscomplete_title") }}--></h4>

            <div>
              <p class="card-category text-muted">{{ $t("dashboard.repairsidleperperiodbyasf_subtitle") }}</p>
              <div class="row">
                <div class="col-md-4">
                  <multiselect
                    v-model="asf_value"
                    :options="asfs"
                    :custom-label="asfLabel"
                    :placeholder="$t('text.select')"
                    label="name"
                    track-by="id"
                    class="b-form-btn-label-control"
                    @open="getAsfs"
                  ></multiselect>
                </div>

                <div class="col-md-4">
                  <a
                    @click.prevent="selectAllAsfs"
                    class="btn btn-primary px-2 rounded"
                    href
                  >{{$t('button.showAllAsfs')}}</a>
                </div>
              </div>

            </div>

        </template>
        <br />
        <div class="container py-4">
          <slot name="loading">
            <div v-if="!loaded" class="lds-container">
              <div class="lds-ring">
                <div></div><div></div><div></div><div></div>
              </div>
            </div>
          </slot>
          <bar v-if="loaded" :chartdata="chartdata" :options="options" style="height: 500px"></bar>
        </div>

        <!-- <div class="mt-2 h6" v-if="loaded">
            <slot v-for="(label, index) in chartdata.labels">
                <small class="mr-2 d-inline-block" :key="index">
                    <i class="fas fa-circle" :style="'color:'+colors.fill[index]"></i>
                    {{ label }}
                </small>
            </slot>
        </div> -->
    </card>
</template>

<script>
import { mapState } from "vuex";
import { Bar } from "@/components/index";
import $http from "@/helpers/api";
import { generateColors } from "@/helpers/filters";
export default {
  name: "RepairsIdlePerPeriodByASF",
  components: { Bar },
  computed: {
    ...mapState("asfs", {
      asfs: "all"
    }),
    asf() {
      return this.$store.getters["auth/getAsf"];
    },
    now() {
      return new Date();
    }
  },
  data: () => ({
    loaded: false,
    asf_value: "",
    asf_id: "",
    colors: [],
    chartdata: {
      labels: [],
      datasets: []
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      layout:{
        padding:30
      },
      legend: {
        display: true,
        position: "bottom",
      },
      scales: {
        xAxes: [
          {
            stacked: true,
            display: true
          }
        ],

        // And this will affect the horizontal lines (yAxe) of your dataset
        yAxes: [
          {
            stacked: true,
            ticks: {
                min: 0,
                stepSize: 1
            },
            gridLines: {
              drawBorder: false,
              borderDash: [3, 3]
            }
          }
        ]
      }
    }
  }),
  methods: {
    asfLabel({ name, vat }) {
      return `${name} — ${vat}`;
    },
    selectAllAsfs() {
      this.asf_id = "";
      this.asf_value = "";

      this.getData();
    },
    getAsfs() {
      this.$store.dispatch("asfs/getAllAsfs", "name");
    },
    getData() {
      this.loaded = false;
      let periods_get_param = "&periods[]=1,5&periods[]=6,10&periods[]=11,15&periods[]=16,20&periods[]=21,25&periods[]=25,30";

      let url = "/stats/repairs/by_status?asf="+ this.asf_id + periods_get_param;
      $http.get(url).then(resp => {

        let dataset = [];

        let data = Object.entries(resp.data.data);

        this.colors = {
          fill: generateColors(data.length, "B3"),
          border: generateColors(data.length)
        };

        let colori = 0;

        for (const item of data){
          dataset.push(
            {
              label: item[0],
              data: item[1],
              backgroundColor: this.colors.fill[colori],
              borderColor: this.colors.border[colori],
              borderWidth: "1",
              hoverBackgroundColor: this.colors.border[colori]
            }
            );
          colori++;

          };

        this.chartdata = {
          labels: resp.data.labels,
          datasets: dataset
        };

        this.loaded = true;
      });
    }
  },
  watch: {
    data: function (){
      this._chart.destroy();
    },
    asf_value: function(newData) {
      this.asf_id = newData.id;

      this.getData();
    }
  },
  mounted() {
    this.getData();
  }
};
</script>
